import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { off } from "process";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { GroupService } from "../../Report/report-services/group.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AddToGroupExistingRequest } from "./shared/AddToGroupExistingRequest";
import { AddToGroupLoadPersonRequest } from "./shared/AddToGroupLoadPersonRequest";
import { AddToGroupNewRequest } from "./shared/AddToGroupNewRequest";
import { DataService_AddToGroup } from "./shared/data.sevice";
import { PersonLoadInfo } from "./shared/PersonLoadInfo";

@Component({
	selector: "app-add-to-group",
	templateUrl: "./add-to-group.component.html",
	styleUrls: ["./add-to-group.component.css"],
})
export class AddToGroupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private groupService: GroupService,
		private personService: PersonSelectorService,
		private addToGroupService: DataService_AddToGroup,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SchoolSubscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});

		this.PersonSubscription = this.personService.onSelectedMultiplePersons().subscribe((lstPersonIDs) => {
			this.onAddToGroup(lstPersonIDs);
		});
	}

	ngOnDestroy() {
		this.SchoolSubscription.unsubscribe();
		this.PersonSubscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	SchoolSubscription: any;
	PersonSubscription: any;

	School: any;

	GroupOption: string = "Existing";

	AddGroupActions: boolean = false;

	LoadingGroup: boolean = false;
	SelectedGroup: any;
	lstGroup: any = [];

	GroupName: string = "";

	SelectStudentExpand: boolean = true;
	StudentsToAddExpand: boolean = true;

	errorMessage: string = "";
	Processing: boolean = false;

	lstPersonToAdd: PersonLoadInfo[] = []; //Students from selector
	lstPerson: any = []; //Loaded data
	loading: boolean = false;

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	loadGroup() {
		this.errorMessage = "";

		if (this.School == undefined) {
			return;
		}

		this.LoadingGroup = true;

		this.lstGroup = [];

		var result = this.groupService.loadGroupList("", this.School.SchoolID);
		result.subscribe(
			(response: any) => {
				this.lstGroup = response;
				this.lstGroup = this.lstGroup.filter((g) => g.GroupID > 0);

				if (this.lstGroup.length > 0) {
					this.SelectedGroup = this.lstGroup[0];
				} else {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "N/A",
					});

					this.SelectedGroup = this.lstGroup[0];
				}

				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	loadPersonInfo() {
		this.errorMessage = "";

		//Get list of students that haven't been loaded
		var lstToLoad: number[] = [];

		//Start from end and take non-loaded entries that were added recently
		for (var z = this.lstPersonToAdd.length - 1; z >= 0; z--) {
			var next = this.lstPersonToAdd[z];

			if (next.Loaded == false) {
				lstToLoad = [...lstToLoad, next.PersonID];
				next.Loaded = true;
			} else {
				break; //Hit end of non-loaded entries (New ones get added to end of list)
			}
		}

		if (lstToLoad.length == 0) {
			return;
		}

		this.loading = true;

		let parms: AddToGroupLoadPersonRequest = {
			lstPersonIDs: lstToLoad,
		};

		//
		// Call WS
		//

		var result = this.addToGroupService.AddToGroupPersonSelectList(parms);
		result.subscribe(
			(response: any) => {
				for (var z = 0; z < response.length; z++) {
					var next = response[z];

					var found = false;
					for (var x = 0; x < this.lstPerson.length; x++) {
						var nextPerson = this.lstPerson[x];

						if (next.PersonID == nextPerson.PersonID) {
							found = true;
							break;
						}
					}

					if (!found) {
						this.lstPerson = [...this.lstPerson, next];
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onFinish() {
		this.errorMessage = "";

		if (this.GroupOption == "Existing") {
			this.FinishExistingGroup();
		} else if (this.GroupOption == "New") {
			this.FinishNewGroup();
		}
	}

	FinishExistingGroup() {
		if (this.SelectedGroup == null || this.SelectedGroup.GroupID <= 0) {
			this.errorMessage = "Select a group to assign students to";
			return;
		}

		var lstPIDs: number[] = [];

		for (var z = 0; z < this.lstPerson.length; z++) {
			var next = this.lstPerson[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		if (lstPIDs.length == 0) {
			this.errorMessage = "Select students from the selector to add to the group";
			this.SelectStudentExpand = true;
			return;
		}

		this.Processing = true;

		let parms: AddToGroupExistingRequest = {
			GroupID: this.SelectedGroup.GroupID,
			AddGroupActions: this.AddGroupActions == true ? 1 : 0,
			lstPersonIDs: lstPIDs,
		};

		var result = this.addToGroupService.AddToGroupExisting(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Students were added to the group successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.lstPerson = [];
							this.lstPersonToAdd = [];
							this.AddGroupActions = false;
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add students to the group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	FinishNewGroup() {
		if (this.GroupName == null || this.GroupName == "" || this.GroupName.length == 0) {
			this.errorMessage = "Enter group name to create a new group with the selected students";
			return;
		}

		var lstPIDs: number[] = [];

		for (var z = 0; z < this.lstPerson.length; z++) {
			var next = this.lstPerson[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		if (lstPIDs.length == 0) {
			this.errorMessage = "Select students from the selector to add to the group";
			this.SelectStudentExpand = true;
			return;
		}

		this.Processing = true;

		let parms: AddToGroupNewRequest = {
			SchoolID: this.School.SchoolID,
			GroupName: this.GroupName,
			lstPersonIDs: lstPIDs,
		};

		var result = this.addToGroupService.AddToGroupNew(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Students were added to the group successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.GroupName = "";
							this.lstPerson = [];
							this.lstPersonToAdd = [];
							this.loadGroup();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add students to the group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////
	onAddToGroup(lstPersonIDs: number[]) {
		this.errorMessage = "";

		//
		// Go through Person IDs
		//
		for (var z = 0; z < lstPersonIDs.length; z++) {
			var nextID = lstPersonIDs[z];

			// If it's not already in the list, add it
			var found = false;
			for (var x = 0; x < this.lstPersonToAdd.length; x++) {
				var nextPersonInfo = this.lstPersonToAdd[x];

				if (nextID == nextPersonInfo.PersonID) {
					found = true;
				}
			}

			if (!found) {
				var newInfo: PersonLoadInfo = {
					PersonID: nextID,
					Loaded: false, //Not loaded yet
				};

				this.lstPersonToAdd = [...this.lstPersonToAdd, newInfo];
			}
		}

		this.loadPersonInfo();
	}

	onRemoveAll() {
		this.errorMessage = "";

		this.lstPerson = [];
		this.lstPersonToAdd = [];
	}

	onRemovePerson(Person) {
		this.errorMessage = "";

		this.lstPerson = this.lstPerson.filter((p) => p.PersonID != Person.PersonID);
		this.lstPersonToAdd = this.lstPersonToAdd.filter((p) => p.PersonID != Person.PersonID);
	}

	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		if (this.GroupOption == "Existing") {
			this.loadGroup();
		}
	}

	onGroupOptionChange(val) {
		this.GroupOption = val;

		if (this.GroupOption == "Existing") {
			this.loadGroup();
		}
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingGroup == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////
}
